import React from 'react';
import {get} from 'lodash';
import className from 'classnames';
import moment from 'moment';
import axios from 'axios';

import {
  metaLoading,
} from '../lib/helpers';

import UserWithImage from './UserWithImage';
import UserWithImageList from './UserWithImageList';
import Loading from './Loading';
import LoadMore from './LoadMore';

class ChatList extends React.Component {
  state = {
    ...metaLoading,
    chats: [],
  }

  componentDidMount = () => {
    this.setState({chats: get(this.props, 'chats')})
  }

  componentDidUpdate() {
    //this._load()
  }

  getChats = () => {
    axios.get(`/${gon.currentProvider}/api/chats`, {
      params: {
        user_id: get(this.props, 'userId'),
        per: 20,
        page: get(this.state, 'meta.page') + 1,
      }
    })
    .then((res) => {
      this.setState((prevState) => ({
        meta: {
          ...prevState.meta,
          isLoading: false,
        },
      }), () => {
        const data = get(res, 'data.chats')
        if (res.status == 200 && get(res, 'data')) {
          this.setState((prevState) => ({
            chats: [
              ...prevState.chats,
              ...data,
            ],
            meta: {
              ...prevState.meta,
              isFullyLoaded: get(data, 'length', 0) == 0 ? true : false,
              page: get(prevState, 'meta.page') + 1,
            },
          }))
        }
      })
    })
    .then(() => {
      this.props.onLoadMore(this.state.chats)
    })
  }

  _load = () => {
    this.setState((prevState) => ({
      meta: {
        ...prevState.meta,
        isLoading: true,
      },
    }), () => {
      this.getChats()
    })
  }

  render = () => {
    return (
      <Loading
        isLoading={get(this.state, 'meta.isLoading') && get(this.state, 'chats.length', 0) == 0}
      >
        <div className='SearchChat__wrapper-inner'>
          <div className='SearchChat'>
            <div className='SearchChat__row'>
              <div className='SearchChat__col SearchChat__col--th'>Chat ID</div>
              <div className='SearchChat__col SearchChat__col--th'>With users</div>
              <div className='SearchChat__col SearchChat__col--th'>Created date</div>
            </div>

            {get(this.state, 'chats', []).map((chat, i) => (
              <div
                key={i}
                className={className('SearchChat__row', {
                  'SearchChat__row--active': chat.id === get(this.props, 'activeChatId')
                })}
                onClick={this.props.onChangeActiveChatId(chat.id)}
              >
                <div className='SearchChat__col'>{chat.id}</div>

                <div className='SearchChat__col SearchChat__col--2'>
                  <div className='SearchChat__content'>
                    <div className='SearchChat__user'>
                      {get(chat, 'users.length') > 1 ?
                        <UserWithImageList users={get(chat, 'users')}/>
                      :
                        <UserWithImage user={get(chat, 'users[0]')}/>
                      }
                    </div>

                    <p className='SearchChat__p'>{get(chat, 'lastMessage.text')}</p>

                    <div className='SearchChat__footer'>
                      <p className='SearchChat__time'>
                      <strong>Created at</strong> {moment(chat.createdAt).format('YYYY-MM-DD HH:mm')}
                      </p>

                      <p className='SearchChat__reported'>
                      <strong>Reported</strong> <a>{chat.reportedCount}</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <LoadMore
            klassName='SearchChat__row'
            onLoadMore={this._load}
            meta={this.state.meta}
          />
        </div>
      </Loading>
    );
  }
}

export default ChatList;
